import { ErrorOutline, Groups, Visibility, Work } from '@mui/icons-material';
import { twMerge } from '@sortlist-frontend/design-system';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import type { ReactNode } from 'react';

import { homeConfig } from '_features/home/home.config';

interface ProblemCardProps {
  icon: ReactNode;
  title: string;
  description: string;
}

const ProblemCard = ({ icon, title, description }: ProblemCardProps) => (
  <div className="bg-white rounded-2xl p-8 text-center shadow-md">
    <div
      className={twMerge(
        'w-12 h-12 rounded-xl flex items-center justify-center mb-5 mx-auto',
        'bg-primary-200 text-primary-500',
      )}>
      {icon}
    </div>
    <h3 className="text-lg font-bold text-secondary-950 mb-2">{title}</h3>
    <p className="text-secondary-600 leading-relaxed">{description}</p>
  </div>
);

export const ProblemSection = () => {
  const { t } = useTranslation(homeConfig.i18nNamespaces);

  return (
    <section className="py-32 bg-secondary-100">
      <div className="container-lg px-6">
        <header className="text-center mb-16">
          <h2 className="font-serif text-4xl font-bold text-secondary-950 mb-4 tracking-tight">
            {t('home:sections.problem.title')}
          </h2>
          <p className="text-lg text-secondary-600 max-w-xl mx-auto">{t('home:sections.problem.subtitle')}</p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <ProblemCard
            icon={<ErrorOutline />}
            title={t('home:sections.problem.pipeline.title')}
            description={t('home:sections.problem.pipeline.description')}
          />
          <ProblemCard
            icon={<Groups />}
            title={t('home:sections.problem.referrals.title')}
            description={t('home:sections.problem.referrals.description')}
          />
          <ProblemCard
            icon={<Work />}
            title={t('home:sections.problem.coldOutreach.title')}
            description={t('home:sections.problem.coldOutreach.description')}
          />
          <ProblemCard
            icon={<Visibility />}
            title={t('home:sections.problem.visitors.title')}
            description={t('home:sections.problem.visitors.description')}
          />
        </div>
      </div>
    </section>
  );
};
